<div *ngIf="showBanner" 
     class="pwa-install-banner"
     [class.closing]="isClosing"
     role="banner"
     [attr.aria-label]="'Install ' + tenantName + ' App'">
  <div class="banner-container">
    <div class="banner-content">
      <!-- App Icon -->
      <div class="banner-icon">
        <img [src]="appIcon" 
             (error)="$any($event.target).src = '/assets/icons/icon-96x96.png'"
             [alt]="tenantName + ' App Icon'" 
             class="app-icon" />
      </div>

      <!-- Text Content -->
      <div class="banner-text">
        <h3 class="banner-title">Install {{ tenantName }} App</h3>
        <p class="banner-description">
          Get the best learning experience! Install our app for offline access and faster performance.
        </p>
      </div>

      <!-- Action Buttons -->
      <div class="banner-actions">
        <button 
          type="button"
          class="btn-install"
          (click)="onInstall()"
          [attr.aria-label]="'Install ' + tenantName + ' App'">
          Install Now
        </button>
        <button 
          type="button"
          class="btn-close"
          (click)="onClose()"
          aria-label="Close banner">
          <svg xmlns="http://www.w3.org/2000/svg" 
               class="close-icon" 
               fill="none" 
               viewBox="0 0 24 24" 
               stroke="currentColor">
            <path stroke-linecap="round" 
                  stroke-linejoin="round" 
                  stroke-width="2" 
                  d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>
